import { defineComponent } from 'vue';
import { mapWritableState } from 'pinia';
import { useLocationStore } from '@/store/LocationStore';
import { useRegisterTestStore } from '@/store/RegisterTestStore';
import { Validator } from '@/validator/Validator';
import FloatingCard from '@/components/Shared/RegisterTest/FloatingCard/FloatingCard.vue';
import BaseInput from '@/components/BaseForm/BaseInput/BaseInput.vue';
import BaseSelect from '@/components/BaseForm/BaseSelect/BaseSelect.vue';
import ThemesHelper from '@/helpers/ThemesHelper';
import AlertBox from '@/components/AlertBox/AlertBox.vue';
import NoIdentificationModal from '@/components/Modals/Hiv/NoIdentificationModal/NoIdentificationModal.vue';

export default defineComponent({
  props: {
    active: {
      type: Boolean,
    },
  },
  components: {
    FloatingCard,
    BaseInput,
    BaseSelect,
    AlertBox,
    NoIdentificationModal
  },
  computed: {
    ...mapWritableState(useRegisterTestStore, ['canJumpNext']),
    ...mapWritableState(useRegisterTestStore, ['patient']),
    ...mapWritableState(useRegisterTestStore, ['registerTestId']),
    validRequiredFields() {
      if (this.patient.name || this.patient.document || this.patient.email) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    patient: {
      handler: function () {
        setTimeout(() => {
          if (this.active) {
            this.canJumpNext = this.isValidForm(false);
          }
        }, 200);
      },
      deep: true,
    },
  },
  data() {
    return {
      StepContent: ThemesHelper.getThemeParams('testStepSixContents'),
      states: [{ false: false }],
      locationStore: useLocationStore(),
      registerTestStore: useRegisterTestStore(),
      nameFieldValidations: [
        { validation: 'requiredField', message: 'Você deve informar seu nome completo.' },
      ],
      cpfFieldValidations: [
        { validation: 'requiredField', message: 'Você deve informar seu CPF.' },
        { validation: 'validCpf', message: 'O campo aceita apenas CPF válido.' },
      ],
      emailFieldValidations: [
        { validation: 'requiredField', message: 'Você deve informar seu e-mail.' },
        { validation: 'validEmail', message: 'O campo aceita apenas e-mail válido.' },
      ],
      removeMessages: false,
    };
  },
  methods: {
    errorValidation() {
      this.isValidForm();
    },
    isValidForm(showErrors = true) {
      const validator = Validator.validateForm(this.$refs, showErrors);
      this.removeMessages = (validator) ? true : false;
      return validator;
    },
    isValidStep() {
      return this.isValidForm(false);
    },
    toggleModal(status: boolean) {
      const el: any = this.$refs['base-modal'];
      el.toggleBaseModal(status);
    },
    setAnimationType(animationName: string) {
      setTimeout(() => {
        const baseModal: any = this.$refs['base-modal'];
        switch (animationName) {
          case 'setNextDismissAnimation':
            baseModal.setNextDismissAnimation();
            break;
          case 'setNextShowAnimation':
            baseModal.setNextShowAnimation();
            break;
          case 'setPreviousDismissAnimation':
            baseModal.setPreviousDismissAnimation();
            break;
          case 'setPreviousShowAnimation':
            baseModal.setPreviousShowAnimation();
            break;
        }
      }, 1);
    },
  },
});
